import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { AuthService } from './app/core/service/auth/auth.service';

bootstrapApplication(AppComponent, appConfig)
  .then(appRef => {
    const injector = appRef.injector;
    const authService = injector.get(AuthService);
    return authService.initAuth().catch(err => {
      console.warn('Falha ao inicializar OAuth (discovery document):', err);
    });
  })
  .catch(err => console.error(err));
